/**
 * it locale — Italian (Italy, it-IT)
 *
 * Extracted from all frontend source files (Issue #18 — i18n).
 * Falls back to pt-BR for any missing key.
 */
export const it: Record<string, string> = {
  // ---------------------------------------------------------------------------
  // common — shared strings used across multiple pages/components
  // ---------------------------------------------------------------------------
  'common.loading': 'Caricamento...',
  'common.checkSpam': 'Se non lo ricevi entro qualche minuto, controlla la cartella spam o posta indesiderata.',
  'common.checkSpamThirdParty': 'Se non lo ricevono entro qualche minuto, chiedi loro di controllare la cartella spam o posta indesiderata.',
  'common.close': 'Chiudi',
  'common.cancel': 'Annulla',
  'common.filter': 'Filtra',
  'common.from': 'Da',
  'common.to': 'A',
  'common.all': 'Tutti',
  'common.type': 'Tipo',
  'common.status': 'Stato',
  'common.origin': 'Origine',
  'common.date': 'Data',
  'common.file': 'File',
  'common.value': 'Valore',
  'common.confidence': 'Confidenza',
  'common.source': 'Origine',
  'common.field': 'Campo',
  'common.yes': 'Sì',
  'common.no': 'No',
  'common.email': 'E-mail',
  'common.processing': 'Elaborazione...',
  'common.error': 'Errore',
  'common.dash': '—',
  'common.filterPlaceholder': 'Filtra...',
  'common.importId': 'Import ID',
  'common.corrected': 'corretto',
  'common.errorPrefix': 'Errore: ',

  // Document type labels
  'common.doctype.nfe': 'NF-e',
  'common.doctype.nfse': 'NFS-e',
  'common.doctype.nfcom': 'NFCom',
  'common.doctype.email': 'E-mail',
  'common.doctype.zip': 'ZIP',
  'common.doctype.unknown': 'Sconosciuto',

  // Legal document labels
  'common.legal.terms': 'Termini di Utilizzo',
  'common.legal.privacy': 'Informativa sulla Privacy',
  'common.legal.cookies': 'Informativa sui Cookie',
  'common.legal.termsShort': 'Termini',
  'common.legal.privacyShort': 'Privacy',
  'common.legal.cookiesShort': 'Cookie',
  'common.legal.custodia': 'Termini di Custodia',
  'common.legal.back': 'Indietro',

  // ---------------------------------------------------------------------------
  // app — App.tsx
  // ---------------------------------------------------------------------------
  'app.loading': 'Caricamento...',

  // ---------------------------------------------------------------------------
  // home — Home.tsx
  // ---------------------------------------------------------------------------
  'home.title': 'Aura Nota',
  'home.subtitle': 'Strumento di cattura ed estrazione strutturata di fatture fiscali brasiliane (NFS-e, NF-e e telecom).',
  'home.card.upload.title': 'Caricamento',
  'home.card.upload.desc': 'Ricevi PDF, XML e immagini di documenti.',
  'home.card.extraction.title': 'Estrazione',
  'home.card.extraction.desc': 'OCR, XML e LLM per leggere i campi automaticamente.',
  'home.card.review.title': 'Revisione',
  'home.card.review.desc': 'Interfaccia umana per convalidare e correggere i dati.',
  'home.hero.title': 'Aura Nota — Cattura ed estrazione intelligente di fatture fiscali',
  'home.hero.subtitle': 'Automatizza la lettura di NFS-e, NFCom e ricevute con l\'IA. Estrai, valida ed esporta i campi fiscali in pochi secondi.',
  'home.hero.cta.signup': 'Inizia gratis',
  'home.hero.cta.pricing': 'Vedi i piani',
  'home.features.title': 'Funzionalita',
  'home.features.extraction.title': 'Estrazione Automatica',
  'home.features.extraction.desc': 'Campi fiscali estratti in pochi secondi con l\'IA',
  'home.features.lgpd.title': 'Conformita LGPD',
  'home.features.lgpd.desc': 'Server nell\'Unione Europea con DPA, crittografia in transito e a riposo, DSAR e consenso integrati',
  'home.features.multilayout.title': 'Multi-layout',
  'home.features.multilayout.desc': 'NFS-e, NFCom, ricevute e altro',
  'home.features.export.title': 'Esportazione Strutturata',
  'home.features.export.desc': 'JSON, CSV e integrazione con il tuo ERP',
  'home.pricing.teaser.title': 'Piani a partire da R$ 0',
  'home.pricing.teaser.desc': 'Inizia gratis e cresci in base alla domanda. Senza carta di credito.',
  'home.pricing.teaser.cta': 'Vedi i piani',
  'home.footer.login': 'Accedi',
  'home.footer.signup': 'Registrati',
  'home.footer.pricing': 'Piani',
  'home.footer.dsar': 'DSAR',
  'home.footer.terms': 'Termini',
  'home.footer.privacy': 'Privacy',
  // Issue #594: sezioni della landing pubblica (visitatore).
  'home.howItWorks.title': 'Come funziona',
  'home.howItWorks.step1.title': 'Invia le tue fatture',
  'home.howItWorks.step1.desc': 'Inoltra i documenti alla tua e-mail di acquisizione dedicata o carica manualmente PDF, XML e immagini.',
  'home.howItWorks.step2.title': 'Estrazione automatica',
  'home.howItWorks.step2.desc': 'L\'XML viene letto direttamente; PDF e immagini passano per OCR e IA per estrarre i campi fiscali.',
  'home.howItWorks.step3.title': 'Rivedi in sicurezza',
  'home.howItWorks.step3.desc': 'I campi a bassa confidenza vanno nella coda di revisione — ogni correzione è registrata nella traccia di audit.',
  'home.howItWorks.step4.title': 'Esporta nel tuo ERP',
  'home.howItWorks.step4.desc': 'Scarica i dati strutturati in JSON o CSV e inviali al tuo sistema contabile o al tuo commercialista.',
  'home.captures.title': 'Cosa acquisiamo',
  'home.captures.nfse.title': 'NFS-e',
  'home.captures.nfse.desc': 'Fatture di servizi in PDF e XML nei più diversi layout e fornitori municipali.',
  'home.captures.nfcom.title': 'NFCom / NFT (modello 62)',
  'home.captures.nfcom.desc': 'Fatture telecom con template dedicati ai principali operatori e un layout generico.',
  'home.captures.nfe.title': 'NF-e e NFC-e',
  'home.captures.nfe.desc': 'XML di fatture di merci e coupon elettronici letti direttamente, senza OCR.',
  'home.captures.others.title': 'Ricevute, ZIP ed e-mail',
  'home.captures.others.desc': 'Ricevute e documenti scansionati via OCR/IA, oltre agli allegati in file ZIP ed e-mail (.eml).',
  'home.personas.title': 'Per chi è',
  'home.personas.company.title': 'Aziende',
  'home.personas.company.desc': 'La finanza inoltra le fatture all\'e-mail di acquisizione ed esporta i dati pronti per l\'ERP o il commercialista.',
  'home.personas.accounting.title': 'Studi contabili',
  'home.personas.accounting.desc': 'Piano Team con fino a 5 utenti, profilo contabile e documenti separati per cliente.',
  'home.personas.dev.title': 'Sviluppatori',
  'home.personas.dev.desc': 'Integra l\'acquisizione nel tuo sistema tramite l\'API — disponibile nel piano Enterprise, su richiesta.',
  'home.diff.title': 'Differenziali',
  'home.diff.dedup.title': 'Deduplicazione automatica',
  'home.diff.dedup.desc': 'La stessa fattura non entra due volte: rileviamo i duplicati tramite l\'hash del file e la chiave di accesso della NF.',
  'home.diff.audit.title': 'Traccia di audit',
  'home.diff.audit.desc': 'Ogni azione su un documento è registrata — chi l\'ha fatta, quando e perché (LGPD).',
  'home.faq.title': 'Domande frequenti',
  'home.faq.q1': 'Quali tipi di documento elabora Aura Nota?',
  'home.faq.a1': 'NFS-e (PDF e XML di vari layout municipali), fatture NFCom/NFT modello 62, NF-e e NFC-e in XML, ricevute e altri PDF o immagini via OCR. Sono accettati anche file ZIP ed e-mail con allegati.',
  'home.faq.q2': 'Come funziona l\'acquisizione via e-mail dedicata?',
  'home.faq.a2': 'Ogni organizzazione riceve un indirizzo di acquisizione esclusivo. Basta inoltrare le e-mail con le fatture in allegato — entrano automaticamente nella coda di elaborazione.',
  'home.faq.q3': 'Conservate i file originali?',
  'home.faq.a3': 'No. Il file viene elaborato e scartato; conserviamo solo i dati estratti e i metadati per il periodo di conservazione configurabile della tua organizzazione (predefinito: 5 anni).',
  'home.faq.q4': 'Serve una carta di credito per iniziare?',
  'home.faq.a4': 'No. Il piano Free include 10 documenti al mese e non richiede carta. Fai l\'upgrade quando ti serve più volume o più utenti.',
  'home.faq.q5': 'Posso annullare quando voglio?',
  'home.faq.a5': 'Sì. L\'annullamento ha effetto alla fine del periodo già pagato — senza addebito immediato e senza penali.',
  'home.faq.q6': 'Dove sono ospitati i miei dati?',
  'home.faq.a6': 'Su un server nell\'Unione Europea (Francia), con contratto di trattamento dei dati (DPA) e Clausole Contrattuali Standard, in conformità con la LGPD. I dettagli sono nella Politica sulla Privacy.',
  'home.pricing.teaser.ctaSignup': 'Crea account gratuito',

  // ---------------------------------------------------------------------------
  // login — Login.tsx
  // ---------------------------------------------------------------------------
  'login.title': 'Accedi',
  'login.subtitle': 'Accedi al tuo account Aura Nota.',
  'login.email': 'E-mail',
  'login.password': 'Password',
  'login.submit': 'Accedi',
  'login.submitting': 'Accesso in corso...',
  'login.noAccount': 'Non hai un account?',
  'login.signupLink': 'Registrati',
  'login.error.auth': 'Errore di autenticazione.',
  'session.expired': 'La tua sessione è scaduta. Accedi di nuovo.',
  'session.loginAgain': 'Accedi di nuovo',

  // ---------------------------------------------------------------------------
  // layout — Layout.tsx
  // ---------------------------------------------------------------------------
  'layout.brand': 'Aura Nota',
  'layout.nav.home': 'Home',
  'layout.nav.upload': 'Caricamento',
  'layout.nav.documents': 'Documenti',
  'layout.nav.billing': 'Fatturazione',
  'layout.nav.quota': 'Quota',
  'layout.nav.subscription': 'Abbonamento',
  'layout.nav.myAccount': 'Il mio Account',
  'layout.account': 'Account',
  'layout.logout': 'Esci',
  'layout.login': 'Accedi',
  'layout.footer.terms': 'Termini di Utilizzo',
  'layout.footer.privacy': 'Informativa sulla Privacy',
  'layout.footer.cookies': 'Informativa sui Cookie',
  'layout.footer.tagline': 'Aura Nota · cattura ed estrazione di fatture fiscali',

  // ---------------------------------------------------------------------------
  // consent — ConsentGate.tsx
  // ---------------------------------------------------------------------------
  'consent.title': 'Consenso LGPD',
  'consent.intro': 'Per continuare a utilizzare Aura Nota, devi accettare la versione vigente ({version}) dei seguenti documenti legali:',
  'consent.acceptLabel': 'Ho letto e accetto i Termini di Utilizzo, l\'Informativa sulla Privacy e l\'Informativa sui Cookie.',
  'consent.submit': 'Accetta e continua',
  'consent.submitting': 'Registrazione...',
  'consent.error.check': 'Errore durante la verifica del consenso.',
  'consent.error.mustAccept': 'Devi accettare i documenti legali per continuare.',
  'consent.error.register': 'Errore durante la registrazione del consenso.',

  // ---------------------------------------------------------------------------
  // errorBoundary — ErrorBoundary.tsx
  // ---------------------------------------------------------------------------
  'errorBoundary.title': 'Si è verificato un errore',
  'errorBoundary.message': 'Si è verificato un errore imprevisto. Prova a ricaricare la pagina.',
  'errorBoundary.reload': 'Ricarica',

  // ---------------------------------------------------------------------------
  // account — Account.tsx
  // ---------------------------------------------------------------------------
  'account.title': 'Il mio account',
  'account.emailLabel': 'E-mail:',
  'account.statusLabel': 'Stato:',
  'account.statusActive': 'Attivo',
  'account.statusInactive': 'Inattivo',
  'account.historyTitle': 'Cronologia dei consensi',
  'account.legalDocsIntro': 'Documenti legali vigenti: ',
  'account.loading': 'Caricamento...',
  'account.error.load': 'Errore durante il caricamento della cronologia.',
  'account.empty': 'Nessun consenso registrato.',
  'account.col.document': 'Documento',
  'account.col.version': 'Versione',
  'account.col.accepted': 'Accettato',
  'account.col.date': 'Data',
  'account.col.ip': 'IP',
  // Modifica dei dati personali ("I miei dati") + cambio password.
  'account.profile.title': 'I miei dati',
  'account.profile.name': 'Nome',
  'account.profile.namePlaceholder': 'Il tuo nome completo',
  'account.profile.nameRequired': 'Inserisci un nome valido.',
  'account.profile.language': 'Lingua',
  'account.profile.email': 'Email',
  'account.profile.emailNote': 'Per cambiare l’email, contatta il supporto/amministratore.',
  'account.profile.save': 'Salva',
  'account.profile.saving': 'Salvataggio...',
  'account.profile.saved': 'Dati aggiornati con successo.',
  'account.profile.error': 'Errore durante il salvataggio.',
  'account.password.title': 'Cambia password',
  'account.password.current': 'Password attuale',
  'account.password.new': 'Nuova password',
  'account.password.confirm': 'Conferma nuova password',
  'account.password.hint': 'Minimo 8 caratteri, con almeno 1 lettera e 1 numero.',
  'account.password.submit': 'Cambia password',
  'account.password.submitting': 'Modifica in corso...',
  'account.password.success': 'Password modificata con successo.',
  'account.password.error': 'Errore durante il cambio della password.',
  'account.password.mismatch': 'La conferma non corrisponde alla nuova password.',
  'account.password.tooShort': 'La nuova password deve contenere almeno 8 caratteri.',

  // ---------------------------------------------------------------------------
  // audit — Audit.tsx
  // ---------------------------------------------------------------------------
  'audit.title': 'Audit LGPD',
  'audit.subtitle': 'Registro degli eventi di elaborazione, accesso e consenso.',
  'audit.exportCsv': 'Esporta CSV',
  'audit.exportJson': 'Esporta JSON',
  'audit.compliance.title': 'Conformità LGPD',
  'audit.compliance.pii': 'PII anonimizzato: nomi dei file e hash sono archiviati senza dati personali diretti',
  'audit.compliance.retention': 'Conservazione: i log di audit sono immutabili e mantenuti secondo la politica di conservazione',
  'audit.compliance.dsar': 'DSAR: diritti dell\'interessato (accesso, eliminazione, portabilità) disponibili tramite API',
  'audit.filter.eventType': 'Tipo di evento',
  'audit.filter.from': 'Da',
  'audit.filter.to': 'A',
  'audit.filter.all': 'Tutti',
  'audit.filter.action.documentUpload': 'Caricamento documento',
  'audit.filter.action.documentUploadDuplicate': 'Caricamento duplicato',
  'audit.filter.action.documentProcess': 'Elaborazione',
  'audit.filter.action.documentDelete': 'Eliminazione',
  'audit.filter.action.consentAccepted': 'Consenso',
  'audit.filter.action.login': 'Accesso',
  'audit.filter.action.logout': 'Disconnessione',
  'audit.loading': 'Caricamento...',
  'audit.error.load': 'Errore durante il caricamento dell\'audit.',
  'audit.empty': 'Nessun evento di audit trovato.',
  'audit.eventCount': '{count} eventi',
  'audit.col.date': 'Data',
  'audit.col.event': 'Evento',
  'audit.col.resource': 'Risorsa',
  'audit.col.details': 'Dettagli',
  'audit.col.user': 'Utente',
  // Action labels (display in table)
  'audit.action.document_upload': 'Caricamento documento',
  'audit.action.document_upload_duplicate': 'Caricamento duplicato',
  'audit.action.document_process': 'Elaborazione',
  'audit.action.document_delete': 'Eliminazione documento',
  'audit.action.consent_accepted': 'Consenso accettato',
  'audit.action.login': 'Accesso',
  'audit.action.logout': 'Disconnessione',

  // ---------------------------------------------------------------------------
  // documents — Documents.tsx
  // ---------------------------------------------------------------------------
  'documents.title': 'Documenti',
  'documents.view.grid': 'Griglia',
  'documents.view.cards': 'Schede',
  'documents.export.csv': 'Esporta CSV',
  'documents.export.excel': 'Esporta Excel',
  'documents.filter.type': 'Tipo',
  'documents.filter.status': 'Stato',
  'documents.filter.all': 'Tutti',
  'documents.filter.from': 'Da',
  'documents.filter.to': 'A',
  'documents.filter.importId': 'Import ID',
  'documents.filter.importIdPlaceholder': 'es: 20260819-001',
  'documents.filter.button': 'Filtra',
  'documents.loading': 'Caricamento...',
  'documents.loadingDetails': 'Caricamento dettagli...',
  'documents.empty': 'Nessun documento trovato.',
  'documents.error.load': 'Errore durante il caricamento dei documenti.',
  'documents.error.loadDetail': 'Errore durante il caricamento del dettaglio.',
  'documents.error.saveField': 'Errore durante il salvataggio del campo.',
  'documents.error.export': 'Errore durante l\'esportazione.',

  // Status filter options
  'documents.status.concluido': 'Completato',
  'documents.status.revisao': 'Revisione',
  'documents.status.erro': 'Errore',
  'documents.status.recebido': 'Ricevuto',

  // Fiscal column headers (grid)
  'documents.col.numero': 'Numero',
  'documents.col.serie': 'Serie',
  'documents.col.prestadorCnpj': 'Prestatore CNPJ',
  'documents.col.prestadorCnpjEmitente': "CNPJ dell'Emittente",
  'documents.col.prestador': 'Prestatore',
  'documents.col.tomadorCnpj': 'Committente CNPJ',
  'documents.col.tomadorCnpjDestinatario': 'CNPJ del Destinatario',
  'documents.col.tomador': 'Committente',
  'documents.col.valorTotal': 'Valore Totale',
  'documents.col.valorServico': 'Valore Servizio',
  'documents.col.dataEmissao': 'Data Emissione',
  'documents.col.municipio': 'Comune',
  'documents.col.codVerificacao': 'Cod. Verifica',
  'documents.col.descricao': 'Descrizione',
  'documents.col.imPrestador': 'IM Prestatore',
  'documents.col.docType': 'Tipo di Documento',
  'documents.col.importId': 'Import ID',
  'documents.col.origin': 'Origine',

  // Cards view headers
  'documents.cards.importId': 'Import ID',
  'documents.cards.file': 'File',
  'documents.cards.type': 'Tipo',
  'documents.cards.status': 'Stato',
  'documents.cards.fields': 'Campi',
  'documents.cards.confidence': 'Confidenza',
  'documents.cards.children': 'Figli',
  'documents.cards.date': 'Inviato',

  // Detail panel
  'documents.detail.close': 'Chiudi',
  'documents.detail.downloading': 'Download...',
  'documents.detail.downloadJson': 'Scarica JSON',
  'documents.detail.downloadXml': 'Scarica XML',
  'documents.detail.downloadPdf': 'Scarica PDF',
  'documents.detail.downloadFields': 'Scarica campi (CSV)',
  'documents.detail.type': 'Tipo',
  'documents.detail.origin': 'Origine',
  'documents.detail.status': 'Stato',
  'documents.detail.avgConfidence': 'Confidenza media',
  'documents.detail.importId': 'ID di importazione',
  'documents.detail.needsReview': 'Richiede revisione: {reason}',
  'documents.detail.reviewReasonDefault': 'Motivo non specificato',
  'documents.detail.error': 'Errore: {error}',
  'documents.detail.extractedFields': 'Campi estratti',
  'documents.detail.col.field': 'Campo',
  'documents.detail.col.value': 'Valore',
  'documents.detail.col.confidence': 'Confidenza',
  'documents.detail.col.origin': 'Origine',
  'documents.detail.col.raw': 'Raw',
  'documents.detail.metadata': 'Metadati',
  'documents.detail.children': 'Documenti figli ({count})',
  'documents.detail.childError': 'errore',
  'documents.detail.processingLog': 'Log di audit dell\'elaborazione',

  // Editable cell tooltip
  'documents.cell.tooltip': '{field} — confidenza {conf}% (doppio clic per modificare)',

  // Provenance modal
  'documents.provenance.title': 'Catena di Origine',
  'documents.provenance.close': 'Chiudi',
  'documents.provenance.noChain': 'Nessun container_chain (file terminale diretto).',
  'documents.delete': 'Elimina',
  'documents.deleteConfirm': 'Sei sicuro di voler spostare questo documento nel cestino? Potrai recuperarlo per 30 giorni.',
  'documents.trash': 'Cestino',
  'documents.restore': 'Ripristina',
  'documents.daysUntilPurge': "Giorni fino all'eliminazione permanente",
  'documents.timeRemaining': "Tempo rimanente: {days} giorni fino all'eliminazione permanente",
  'documents.trashEmpty': 'Il cestino e vuoto.',
  'documents.trashDeletedAt': 'Eliminato il',
  'documents.actions': 'Azioni',
  'documents.error.delete': 'Errore durante lo spostamento del documento nel cestino.',
  'documents.error.restore': 'Errore durante il ripristino del documento.',

  // Batch selection (Feature 2)
  'documents.batch.selectedCount': '{count} selezionati',
  'documents.batch.selectAll': 'Seleziona tutti',
  'documents.batch.deleteTitle': 'Elimina documenti',
  'documents.batch.deleteConfirm': 'Sei sicuro di voler eliminare {count} documento/i? Verranno spostati nel cestino e potranno essere recuperati per 30 giorni.',
  'documents.batch.deletePartialError': 'Errore durante l\'eliminazione di {failed} su {total} documento/i.',

  // ---------------------------------------------------------------------------
  // upload — Upload.tsx
  // ---------------------------------------------------------------------------
  'upload.title': 'Caricamento Documenti',
  'upload.subtitle': 'Invia PDF, XML, e-mail (.eml/.msg), ZIP, HTML o immagini per l\'estrazione automatica dei campi fiscali.',
  'upload.dropzone.text': 'Trascina i file qui o clicca per selezionare',
  'upload.dropzone.formats': 'Formati: {formats} — Max 25 MB',
  'upload.process': 'Elabora ({count} in attesa)',
  'upload.processing': 'Elaborazione...',
  'upload.clear': 'Pulisci',
  'upload.summary': '{done} completati, {errors} errori, {pending} in attesa',
  'upload.filesTitle': 'File inviati',
  'upload.viewResult': 'Vedi risultato',
  'upload.remove': 'Rimuovi',
  'upload.result.type': 'Tipo: {type}',
  'upload.result.origin': 'Origine: {origin}',
  'upload.result.fields': 'Campi: {count}',
  'upload.result.errors': 'Errori: {count}',
  'upload.result.duplicate': 'Duplicato',
  'upload.error.batchNotFound': 'Risultato non trovato nel lotto.',
  'upload.error.cancelledDuplicate': 'Annullato (duplicato non elaborato)',
  'upload.error.timeout': 'Timeout durante l\'elaborazione.',
  // Issue #279: Modalità batch per upload di 3+ file.
  'upload.batch.submitted': 'Lot inviato. Verrai avvisato al completamento.',
  'upload.batch.inProgress': 'Lot in elaborazione: {done}/{total} completati',
  'upload.batch.complete': 'Lot completato: {success} successi, {errors} errori',
  'upload.batch.blocked': 'Attendi il completamento del lot attuale',
  'upload.batch.networkError': 'Il lotto potrebbe essere in elaborazione sul server. Verifica la lista dei documenti prima di reinviare.',
  'upload.batch.checkStatus': 'Verifica stato',

  // Status badge labels
  'upload.status.pending': 'In attesa',
  'upload.status.uploading': 'Caricamento...',
  'upload.status.processing': 'Elaborazione...',
  'upload.status.done': 'Completato',
  'upload.status.error': 'Errore',

  // Result panel
  'upload.result.title': 'Risultato dell\'estrazione',
  'upload.result.close': 'Chiudi',
  'upload.result.file': 'File',
  'upload.result.typeLabel': 'Tipo',
  'upload.result.originLabel': 'Origine',
  'upload.result.time': 'Tempo',
  'upload.result.needsReview': 'Richiede revisione: {reason}',
  'upload.result.reviewReasonDefault': 'Motivo non specificato',
  'upload.result.error': 'Errore: {error}',
  'upload.result.extractedFields': 'Campi estratti',
  'upload.result.col.field': 'Campo',
  'upload.result.col.value': 'Valore',
  'upload.result.col.confidence': 'Confidenza',
  'upload.result.col.origin': 'Origine',
  'upload.result.metadata': 'Metadati',
  'upload.result.children': 'Documenti figli ({count})',
  'upload.result.childError': 'errore',

  // Duplicate modal (single file)
  'upload.duplicate.title': 'NF Duplicata Rilevata',
  'upload.duplicate.intro': 'Questa NF è già stata elaborata precedentemente.',
  'upload.duplicate.type.file': 'File identico',
  'upload.duplicate.type.data': 'Stessa NF (dati)',
  'upload.duplicate.importId': 'Import ID',
  'upload.duplicate.type': 'Tipo',
  'upload.duplicate.file': 'File',
  'upload.duplicate.processedAt': 'Elaborata il',
  'upload.duplicate.whatToDo': 'Cosa vuoi fare?',
  'upload.duplicate.replace': 'Sostituisci',
  'upload.duplicate.replaceDesc': 'rimuove il record precedente e ne crea uno nuovo',
  'upload.duplicate.archive': 'Archivia',
  'upload.duplicate.archiveDesc': 'mantiene il record precedente archiviato e ne crea uno nuovo',
  'upload.duplicate.duplicate': 'Duplica',
  'upload.duplicate.duplicateDesc': 'crea un nuovo record senza modificare il precedente',
  'upload.duplicate.cancel': 'Annulla',
  'upload.duplicate.cancelDesc': 'non elaborare',
  'upload.duplicate.processing': 'Elaborazione...',

  // Batch duplicate modal
  'upload.batchDuplicate.title': '{count} file duplicato/i trovato/i',
  'upload.batchDuplicate.intro': 'I file seguenti sono già stati elaborati precedentemente. Scegli un\'azione per ciascuno. I file non duplicati saranno elaborati normalmente.',
  'upload.batchDuplicate.type.file': 'File identico',
  'upload.batchDuplicate.type.data': 'Stessa NF (dati)',
  'upload.batchDuplicate.existingImportId': 'Import ID esistente',
  'upload.batchDuplicate.existingFile': 'File esistente',
  'upload.batchDuplicate.processedAt': 'Elaborato il',
  'upload.batchDuplicate.replace': 'Sostituisci',
  'upload.batchDuplicate.replaceDesc': 'rimuove il precedente e crea nuovo',
  'upload.batchDuplicate.archive': 'Archivia',
  'upload.batchDuplicate.archiveDesc': 'archivia il precedente e crea nuovo',
  'upload.batchDuplicate.duplicate': 'Duplica',
  'upload.batchDuplicate.duplicateDesc': 'crea nuovo senza modificare il precedente',
  'upload.batchDuplicate.remove': 'Rimuovi',
  'upload.batchDuplicate.removeDesc': 'elimina il record precedente (admin)',
  'upload.batchDuplicate.cancel': 'Annulla',
  'upload.batchDuplicate.cancelDesc': 'non elaborare',
  'upload.batchDuplicate.cancelAll': 'Annulla tutto',
  'upload.batchDuplicate.confirm': 'Conferma decisioni',
  'upload.batchDuplicate.processing': 'Elaborazione...',

  // Notifications (Issue #281)
  'notifications.title': 'Notifiche',
  'notifications.empty': 'Nessuna notifica',
  'notifications.markAllRead': 'Segna tutte come lette',
  'notifications.batchComplete': 'Lotto completato',
  'notifications.justNow': 'adesso',
  'notifications.minutesAgo': '{n} min fa',
  'notifications.hoursAgo': '{n} h fa',
  'notifications.daysAgo': '{n} g fa',  // Sprint 7: Billing / Pricing / Signup

  'layout.nav.pricing': 'Piani',
  'pricing.title': 'Scegli il piano ideale per te',
  'pricing.subtitle': 'Inizia gratis e cresci secondo le tue esigenze. Nessuna carta di credito.',
  'pricing.unlimited': 'Contattaci',
  'pricing.free': 'Gratis',
  'pricing.month': 'mese',
  'pricing.unlimitedDocs': 'Documenti illimitati',
  'pricing.docsPerMonth': '{count} documenti/mese',
  'pricing.popular': 'Più popolare',
  'pricing.feat.upload': 'Caricamento documenti',
  'pricing.feat.exportCsv': 'Esporta CSV',
  'pricing.feat.multiUser': 'Utenti multipli',
  'pricing.feat.audit': 'Registro audit',
  'pricing.feat.apiAccess': 'Accesso API',
  'pricing.feat.prioritySupport': 'Supporto prioritario',
  'pricing.ctaFree': 'Inizia gratis',
  'pricing.ctaPaid': 'Abbonati',
  'pricing.processing': 'Elaborazione...',
  'pricing.pixTitle': 'Paga via PIX',
  'pricing.pixInstructions': 'Scansiona il QR code qui sotto con la tua banca per pagare l\'abbonamento.',
  'pricing.goToBilling': 'Vai a Billing',
  // Issue #593: piani Single/Team/Enterprise (contratto #592) + tabella
  // comparativa nella stessa pagina.
  'pricing.ctaEnterprise': 'Parla con le vendite',
  'pricing.enterpriseMailSubject': 'Aura Nota — Piano Enterprise',
  'pricing.users.one': '1 utente',
  'pricing.users.upTo': 'Fino a {count} utenti',
  'pricing.users.unlimited': 'Utenti illimitati',
  'pricing.feat.exportJson': 'Esporta JSON',
  'pricing.feat.emailCapture': 'Acquisizione via e-mail dedicata',
  'pricing.feat.accountant': 'Utente contabile',
  'pricing.feat.onboarding': 'Onboarding assistito',
  'comparison.title': 'Confronto dei piani',
  'comparison.subtitle': 'Tutte le funzionalità, fianco a fianco.',
  'comparison.feature': 'Funzionalità',
  'comparison.unlimited': 'Illimitato',
  'comparison.row.docs': 'Documenti al mese',
  'comparison.row.users': 'Utenti inclusi',
  'comparison.row.accountant': 'Utente contabile',
  'comparison.row.emailUpload': 'Acquisizione via e-mail dedicata e caricamento manuale',
  'comparison.row.exportJson': 'Esportazione JSON',
  'comparison.row.exportCsv': 'Esportazione CSV',
  'comparison.row.multiUser': 'Multiutente (team)',
  'comparison.row.audit': 'Traccia di audit (LGPD)',
  'comparison.row.apiAccess': 'Accesso API',
  'comparison.row.prioritySupport': 'Supporto prioritario',
  'comparison.row.onboarding': 'Onboarding assistito',
  'signup.title': 'Crea account',
  'signup.subtitle': 'Inizia a usare Aura Nota gratuitamente.',
  'signup.name': 'Nome',
  'signup.company': 'Azienda',
  'signup.email': 'E-mail',
  'signup.password': 'Password',
  'signup.passwordHint': 'Minimo 8 caratteri, 1 lettera e 1 numero.',
  'signup.submit': 'Crea account',
  'signup.submitting': 'Creazione...',
  'signup.error': 'Impossibile creare l\'account.',
  'signup.haveAccount': 'Hai già un account?',
  'signup.loginLink': 'Accedi',
  'signup.successTitle': 'Account creato!',
  'signup.successBody': 'Controlla la tua e-mail per attivare l\'account. Dopo l\'attivazione, potrai accedere.',
  'signup.goLogin': 'Vai al login',
  'billing.title': 'Billing',
  'billing.currentPlan': 'Piano attuale',
  'billing.planLabel': 'Piano',
  'billing.statusLabel': 'Stato',
  'billing.status.active': 'Attivo',
  'billing.status.pending_payment': 'Pagamento in sospeso',
  'billing.status.suspended': 'Sospeso',
  'billing.status.cancelled': 'Annullato',
  'billing.renewsOn': 'Rinnovo il',
  'billing.paymentMethod': 'Metodo di pagamento',
  'billing.usage': 'Utilizzo questo mese',
  'billing.used': '{used} di {limit} documenti',
  'billing.remaining': '{count} rimanenti',
  'billing.unlimited': 'Illimitato',
  'billing.resetsOn': 'Reimposta il {date}',
  'billing.pendingPayment': 'Pagamento in sospeso',
  'billing.invoiceAmount': 'R$ {amount}',
  'billing.dueDate': 'Scadenza: {date}',
  'billing.pixTitle': 'Paga via PIX',
  'billing.pixInstructions': 'Scansiona il QR code con la tua banca. Dopo il pagamento, un admin confermerà e il tuo piano sarà attivato.',
  'billing.invoiceId': 'Fattura: {id}',
  'billing.refresh': 'Aggiorna',
  'billing.upgradePro': 'Passa a Pro',
  'billing.viewPlans': 'Vedi i piani e fai l\'upgrade',
  'billing.cancel': 'Annulla l\'abbonamento',
  'billing.cancelConfirm': 'Sei sicuro di voler annullare il tuo abbonamento?',
  'billing.processing': 'Elaborazione...',
  'signup.consentPrefix': 'Ho letto e accetto i',
  'signup.consentAnd': 'e la',
  'signup.consentRequired': 'Devi accettare i Termini di Utilizzo e l\'Informativa sulla Privacy per creare l\'account.',

  'layout.nav.sefaz': 'Cerca per Chiave',
  'sefaz.title': 'Cerca NF-e per Chiave di Accesso',
  'sefaz.tab.individual': 'Individuale',
  'sefaz.tab.batch': 'Lotto (Excel)',
  'sefaz.individual.label': 'Chiave di Accesso (44 cifre)',
  'sefaz.individual.invalid': 'Chiave non valida: deve avere 44 cifre con cifra di controllo valida',
  'sefaz.individual.valid': 'Chiave valida',
  'sefaz.individual.search': 'Cerca',
  'sefaz.individual.result': 'Risultato della ricerca',
  'sefaz.individual.goToDocs': 'Vedi documento in Documenti',
  'sefaz.status': 'Stato',
  'sefaz.batch.downloadTemplate': 'Scarica Modello Excel',
  'sefaz.batch.dropHere': 'Trascina un file .xlsx qui o clicca per selezionare',
  'sefaz.batch.errorFormat': 'Il file deve essere .xlsx',
  'sefaz.batch.progress': 'Progresso del lotto',
  'sefaz.batch.total': 'Totale',
  'sefaz.batch.processed': 'Elaborate',
  'sefaz.batch.success': 'Successo',
  'sefaz.batch.error': 'Errori',
  'sefaz.batch.status': 'Stato',
  'sefaz.batch.goToDocs': 'Vedi documenti creati',
  'sefaz.batch.history': 'Lotti precedenti',
  'sefaz.batch.export': 'Esporta risultati',
  'layout.nav.sefazGroup': 'Fiscale / SEFAZ',
  'sefaz.nav.status': 'Stato del servizio',
  'sefaz.nav.consulta': 'Ricerca per chiave',
  'sefaz.nav.dfe': 'Distribuzione DF-e per NSU',
  'sefaz.nav.certs': 'Certificati',
  'sefaz.statusPage.title': 'Stato del servizio SEFAZ',
  'sefaz.statusPage.ufLabel': 'UF',
  'sefaz.statusPage.tab.nfe': 'NF-e',
  'sefaz.statusPage.tab.cte': 'CT-e',
  'sefaz.statusPage.tab.mdfe': 'MDF-e',
  'sefaz.statusPage.consult': 'Consulta',
  'sefaz.statusPage.cstat': 'cStat',
  'sefaz.statusPage.xmotivo': 'Motivo',
  'sefaz.statusPage.uf': 'UF',
  'sefaz.statusPage.timestamp': 'Data/ora',
  'sefaz.statusPage.rateLimited': 'Limite di richieste superato. Riprova tra {s}s.',
  'sefaz.statusPage.unavailable': 'Il servizio SEFAZ non è al momento disponibile. Riprova tra poco.',
  'sefaz.gated.title': 'Richiede un certificato A1 configurato',
  'sefaz.gated.body': 'Questa ricerca richiede un certificato digitale A1 collegato all’organizzazione. Registralo in Fiscal/SEFAZ > Certificati.',
  'sefaz.gated.cta': 'Vai a Certificati',
  'sefaz.dfe.title': 'Distribuzione DF-e per NSU',
  'sefaz.dfe.nsuLabel': 'Ultimo NSU (15 cifre)',
  'sefaz.certs.title': 'Gestione dei certificati A1',
  'sefaz.certs.badge': 'Prossimamente',
  'sefaz.certs.body': 'Qui potrai registrare e gestire il certificato digitale A1 dell’organizzazione, necessario per le ricerche SEFAZ autenticate (ricerca per chiave e distribuzione DF-e).',
  // Sprint 14 (issue #482): pagina real de custodia de certificados A1.
  'sefaz.certs.subtitle': 'Certificato digitale A1 (e-CNPJ) usato per le ricerche SEFAZ autenticate.',
  'sefaz.certs.retry': 'Riprova',
  'sefaz.certs.tab.detail': 'Certificato',
  'sefaz.certs.tab.history': 'Cronologia',
  'sefaz.certs.empty.title': 'Nessun certificato registrato',
  'sefaz.certs.empty.body': 'Carica il certificato digitale A1 (.pfx/.p12) dell’organizzazione per abilitare le ricerche SEFAZ autenticate.',
  'sefaz.certs.empty.memberHint': 'L’organizzazione non ha ancora un certificato digitale registrato. Chiedi a un amministratore di caricarlo.',
  'sefaz.certs.empty.cta': 'Carica certificato',
  'sefaz.certs.member.title': 'Certificato digitale dell’organizzazione',
  'sefaz.certs.member.absent': 'Nessun certificato digitale registrato.',
  'sefaz.certs.member.configured': 'Certificato digitale configurato e attivo.',
  'sefaz.certs.member.expiring': 'Il certificato digitale scade tra {n} giorno/i.',
  'sefaz.certs.member.expired': 'Il certificato digitale è scaduto.',
  'sefaz.certs.member.hint': 'La gestione del certificato è riservata agli amministratori dell’organizzazione.',
  'sefaz.certs.expiredBanner': 'Il certificato digitale è scaduto — le ricerche SEFAZ non sono disponibili fino alla rotazione.',
  'sefaz.certs.expiredCta': 'Ruota ora',
  'sefaz.certs.meta.title': 'Certificato in custodia',
  'sefaz.certs.meta.cn': 'Nome (CN)',
  'sefaz.certs.meta.issuer': 'Emittente',
  'sefaz.certs.meta.serial': 'Numero di serie',
  'sefaz.certs.meta.cnpj': 'CNPJ',
  'sefaz.certs.meta.validFrom': 'Valido dal',
  'sefaz.certs.meta.validTo': 'Valido fino al',
  'sefaz.certs.meta.fingerprint': 'Fingerprint SHA-256',
  'sefaz.certs.meta.uploadedAt': 'Caricato il',
  'sefaz.certs.meta.uploadedBy': 'Caricato da',
  'sefaz.certs.meta.lastSession': 'Ultima sessione MCP',
  'sefaz.certs.status.ativo': 'Attivo',
  'sefaz.certs.status.ausente': 'Nessun certificato',
  'sefaz.certs.status.vencendo': 'Scade tra {n} giorni',
  'sefaz.certs.status.expirado': 'Scaduto',
  'sefaz.certs.status.pendente': 'In attesa di consenso',
  'sefaz.certs.status.removido': 'Rimosso',
  'sefaz.certs.actions.rotate': 'Ruota certificato',
  'sefaz.certs.actions.remove': 'Rimuovi certificato',
  'sefaz.certs.upload.titleCreate': 'Carica certificato A1',
  'sefaz.certs.upload.titleRotate': 'Ruota certificato A1',
  'sefaz.certs.upload.dropzone': 'Trascina qui il file del certificato o clicca per selezionare',
  'sefaz.certs.upload.formats': 'Formati accettati: .pfx o .p12 — massimo 64 KB',
  'sefaz.certs.upload.changeFile': 'clicca per cambiare file',
  'sefaz.certs.upload.fileErrorExt': 'File non valido: carica un certificato .pfx o .p12 (A1).',
  'sefaz.certs.upload.fileErrorSize': 'Il file supera il limite di 64 KB.',
  'sefaz.certs.upload.passwordLabel': 'Password del certificato',
  'sefaz.certs.upload.passwordHint': 'La password serve solo a validare il certificato ed è memorizzata cifrata — mai mostrata né salvata nel browser.',
  'sefaz.certs.upload.submitCreate': 'Valida e custodisci',
  'sefaz.certs.upload.submitRotate': 'Valida e ruota',
  'sefaz.certs.upload.successCreate': 'Certificato caricato e custodito con successo.',
  'sefaz.certs.upload.successRotate': 'Certificato ruotato con successo.',
  'sefaz.certs.consent.text': 'Autorizzo Aura Nota a custodire il certificato digitale A1 dell’organizzazione (CNPJ {cnpj}) in forma cifrata, a usarlo esclusivamente per ricerche fiscali per mio conto tramite sessioni transitorie, e riconosco di poter revocare questa autorizzazione e rimuovere il certificato in qualsiasi momento.',
  'sefaz.certs.consent.textNoCnpj': 'Autorizzo Aura Nota a custodire il certificato digitale A1 dell’organizzazione in forma cifrata, a usarlo esclusivamente per ricerche fiscali per mio conto tramite sessioni transitorie, e riconosco di poter revocare questa autorizzazione e rimuovere il certificato in qualsiasi momento.',
  'sefaz.certs.consent.linkLabel': 'Leggi i termini di custodia',
  'sefaz.certs.mismatch.title': 'CNPJ divergente',
  'sefaz.certs.mismatch.body': 'Il CNPJ del nuovo certificato non corrisponde al CNPJ dell’organizzazione. Conferma solo se l’organizzazione ha effettivamente cambiato CNPJ o se questo certificato appartiene al titolare corretto.',
  'sefaz.certs.mismatch.confirm': 'Conferma divergenza e ruota',
  'sefaz.certs.remove.title': 'Rimuovi certificato',
  'sefaz.certs.remove.impact': 'Impatto: le ricerche fiscali (SEFAZ/RFB) di questa organizzazione diventano non disponibili fino al caricamento di un nuovo certificato. Il materiale cifrato viene cancellato immediatamente e la sessione MCP viene chiusa.',
  'sefaz.certs.remove.confirmLabel': 'Comprendo l’impatto e confermo la rimozione del certificato in custodia.',
  'sefaz.certs.remove.confirm': 'Rimuovi definitivamente',
  'sefaz.certs.remove.success': 'Certificato rimosso dalla custodia.',
  'sefaz.certs.history.col.action': 'Azione',
  'sefaz.certs.history.col.user': 'Utente',
  'sefaz.certs.history.col.timestamp': 'Data/ora',
  'sefaz.certs.history.col.ip': 'IP',
  'sefaz.certs.history.empty': 'Nessun evento registrato per questo certificato.',
  'sefaz.certs.history.prev': 'Precedente',
  'sefaz.certs.history.next': 'Successiva',
  'sefaz.certs.history.page': 'Pagina {page} di {pages}',
  'sefaz.certs.history.action.cert_upload': 'Caricamento certificato',
  'sefaz.certs.history.action.cert_view': 'Visualizzazione metadati',
  'sefaz.certs.history.action.cert_rotate': 'Rotazione certificato',
  'sefaz.certs.history.action.cert_delete': 'Rimozione certificato',
  'sefaz.certs.history.action.cert_use': 'Uso in ricerca SEFAZ',
  'sefaz.certs.history.action.cert_consent_grant': 'Consenso registrato',
  'sefaz.certs.history.action.cert_consent_revoke': 'Consenso revocato',
  'sefaz.certs.history.action.cert_session_open': 'Sessione MCP aperta',
  'sefaz.certs.error.invalidPfx': 'Password del certificato errata o file non valido.',
  'sefaz.certs.error.invalidChain': 'Il certificato non è A1 ICP-Brasil (e-CPF, A3 o autofirmati non accettati).',
  'sefaz.certs.error.expired': 'Certificato scaduto — carica un certificato valido.',
  'sefaz.certs.error.cnpjMismatch': 'Il CNPJ del certificato non corrisponde al CNPJ dell’organizzazione.',
  'sefaz.certs.error.rateLimited': 'Limite di tentativi superato. Riprova tra {min} min.',
  'sefaz.certs.error.uploadDisabled': 'Il caricamento dei certificati è disabilitato in questo ambiente.',
  'sefaz.certs.error.noOrgCnpj': 'Registra il CNPJ dell’organizzazione prima di caricare il certificato.',
  'sefaz.certs.error.pfxTooLarge': 'Il file del certificato supera il limite accettato.',
  'sefaz.certs.error.alreadyExists': 'Esiste già un certificato in custodia — usa la rotazione per sostituirlo.',
  'sefaz.certs.error.consentRequired': 'È necessario accettare i termini di custodia per continuare.',
  'sefaz.certs.error.confirmRequired': 'Conferma l’operazione per continuare.',
  'sefaz.certs.error.unavailable': 'Servizio di ricerca fiscale non disponibile. Riprova tra poco.',
  'sefaz.certs.error.forbidden': 'Non hai il permesso per questa azione.',
  'sefaz.certs.error.validation': 'Dati del certificato non validi.',
  'sefaz.certs.error.generic': 'Impossibile completare l’operazione.',

  // catalogo — catalogo collaborativo comuni/provider (S10-T06)
  'layout.nav.catalogo': 'Comuni',
  'catalogo.title': 'Catalogo dei comuni',
  'catalogo.subtitle': 'Mappatura collaborativa comune → provider NFS-e.',
  'catalogo.stats.municipios': 'Comuni coperti',
  'catalogo.stats.provedores': 'Provider supportati',
  'catalogo.stats.ufs': 'Stati coperti',
  'catalogo.stats.pendentes': 'Suggerimenti in sospeso',
  'catalogo.table.title': 'Comuni',
  'catalogo.table.ibge': 'IBGE',
  'catalogo.table.nome': 'Comune',
  'catalogo.table.uf': 'Stato',
  'catalogo.table.provedor': 'Provider',
  'catalogo.table.agregador': 'Aggregatore',
  'catalogo.table.empty': 'Nessun comune trovato.',
  'catalogo.filter.uf': 'Stato',
  'catalogo.filter.provedor': 'Provider',
  'catalogo.filter.busca': 'Cerca comune',
  'catalogo.export': 'Esporta JSON',
  'catalogo.import': 'Importa JSON',
  'catalogo.import.result': 'Importazione: {created} creati, {updated} aggiornati ({total} elementi).',
  'catalogo.suggest.title': 'Suggerisci mappatura',
  'catalogo.suggest.ibge': 'Codice IBGE',
  'catalogo.suggest.nome': 'Comune',
  'catalogo.suggest.uf': 'Stato',
  'catalogo.suggest.provedor': 'Provider',
  'catalogo.suggest.agregador': 'Aggregatore (opzionale)',
  'catalogo.suggest.justificativa': 'Giustificazione (opzionale)',
  'catalogo.suggest.submit': 'Invia suggerimento',
  'catalogo.suggest.success': 'Suggerimento inviato per la moderazione.',
  'catalogo.sugestoes.title': 'Suggerimenti',
  'catalogo.sugestoes.empty': 'Nessun suggerimento.',
  'catalogo.sugestoes.status.pendente': 'In sospeso',
  'catalogo.sugestoes.status.aprovada': 'Approvato',
  'catalogo.sugestoes.status.rejeitada': 'Rifiutato',
  'catalogo.moderation.actions': 'Azioni',
  'catalogo.moderation.approve': 'Approva',
  'catalogo.moderation.reject': 'Rifiuta',
  'catalogo.moderation.rejectPrompt': 'Motivo del rifiuto (opzionale):',
  'catalogo.history.title': 'Cronologia del catalogo',
  'catalogo.history.action': 'Azione',
  'catalogo.history.action.create': 'Creazione',
  'catalogo.history.action.update': 'Aggiornamento',
  'catalogo.history.action.delete': 'Eliminazione',
  'catalogo.history.origem.admin': 'Modifica diretta',
  'catalogo.history.origem.sugestao': 'Suggerimento approvato',
  'catalogo.history.origem.import': 'Importazione',
  'catalogo.history.empty': 'Nessuna modifica registrata.',
  'catalogo.error.generic': 'Impossibile completare l’operazione.',

  // ---------------------------------------------------------------------------
  // onboarding — procedura guidata del tenant (S10-T07, US-S10-007)
  // ---------------------------------------------------------------------------
  'layout.nav.onboarding': 'Onboarding',
  'onboarding.title': 'Onboarding assistito',
  'onboarding.subtitle': 'Configura l’organizzazione passo dopo passo: e-mail, comuni, soglie e un tour dell’interfaccia.',
  'onboarding.progress': '{done} di {total} fasi',
  'onboarding.error.load': 'Errore nel caricamento della checklist di onboarding.',
  'onboarding.error.action': 'Errore nell’esecuzione dell’azione.',
  'onboarding.step.email': 'E-mail',
  'onboarding.step.municipios': 'Comuni',
  'onboarding.step.thresholds': 'Soglie',
  'onboarding.step.tour': 'Tour guidato',
  'onboarding.step.auto': 'rilevato',
  'onboarding.step.autoHint': 'Fase già soddisfatta dalla configurazione attuale dell’organizzazione.',
  'onboarding.step.complete': 'Completa fase',
  'onboarding.step.completeHint': 'La fase può essere completata solo quando la configurazione corrispondente è già salvata.',
  'onboarding.step.done': 'Fase completata',
  'onboarding.nav.prev': 'Indietro',
  'onboarding.nav.next': 'Avanti',
  'onboarding.finish': 'Concludi onboarding',
  'onboarding.help.title': 'Aiuto',
  'onboarding.help.email': 'Configura una casella IMAP per la cattura automatica delle note e/o l’SMTP di invio. Dopo l’onboarding, gestisci tutto in Impostazioni → E-mail.',
  'onboarding.help.municipios': 'Seleziona i comuni da cui la tua organizzazione riceve NFS-e. La selezione proviene dal catalogo collaborativo comune → provider.',
  'onboarding.help.thresholds': 'Definisci le soglie di validazione dell’estrazione. Puoi modificarle dopo in Impostazioni → Soglie.',
  'onboarding.help.tour': 'Il tour mostra le aree principali dell’interfaccia. Puoi saltarlo e completare la fase manualmente.',
  'onboarding.help.link.settingsEmail': 'Apri Impostazioni',
  'onboarding.help.link.settingsThresholds': 'Apri Impostazioni',
  'onboarding.help.link.catalogo': 'Apri il catalogo dei comuni',
  'onboarding.email.title': 'E-mail (cattura e invio)',
  'onboarding.email.subtitle': 'Configura la casella IMAP monitorata e/o il server SMTP dell’organizzazione, con test di connessione.',
  'onboarding.email.imapDetected': 'IMAP configurato',
  'onboarding.email.smtpDetected': 'SMTP configurato',
  'onboarding.email.imapLegend': 'IMAP — cattura delle note',
  'onboarding.email.imapHint': 'Casella e-mail monitorata per la cattura automatica di NFS-e/fatture.',
  'onboarding.email.smtpLegend': 'SMTP — invio e-mail',
  'onboarding.email.smtpHint': 'Server SMTP per l’invio di inviti e notifiche.',
  'onboarding.email.saveImap': 'Salva e testa IMAP',
  'onboarding.email.imapSaved': 'IMAP salvato.',
  'onboarding.email.saveSmtp': 'Salva SMTP',
  'onboarding.email.smtpSaved': 'SMTP salvato.',
  'onboarding.email.testSmtp': 'Testa connessione SMTP',
  'onboarding.email.testOk': 'Test di connessione: {message}',
  'onboarding.email.testFail': 'Test fallito: {error}',
  'onboarding.email.tip.host': 'Indirizzo del server e-mail (es.: imap.esempio.com o smtp.esempio.com).',
  'onboarding.email.tip.password': 'Password o password per app della casella. Memorizzata cifrata.',
  'onboarding.email.tip.testSmtp': 'Salva l’SMTP prima di testare — il test usa la configurazione già persistita.',
  'onboarding.municipios.title': 'Comuni monitorati',
  'onboarding.municipios.subtitle': 'Seleziona dal catalogo i comuni da cui la tua organizzazione riceve NFS-e.',
  'onboarding.municipios.searchPlaceholder': 'Cerca comune per nome...',
  'onboarding.municipios.search': 'Cerca',
  'onboarding.municipios.searching': 'Ricerca...',
  'onboarding.municipios.empty': 'Nessun comune trovato nel catalogo.',
  'onboarding.municipios.selected': 'Selezionato',
  'onboarding.municipios.add': 'Aggiungi',
  'onboarding.municipios.remove': 'Rimuovi',
  'onboarding.municipios.count': '{count} comune/i selezionato/i.',
  'onboarding.municipios.save': 'Salva selezione',
  'onboarding.municipios.update': 'Aggiorna selezione',
  'onboarding.municipios.saved': 'Selezione salvata ({count} comuni).',
  'onboarding.thresholds.title': 'Soglie di validazione',
  'onboarding.thresholds.subtitle': 'Confidenza minima del VLM, approvazione automatica e coda di revisione — valori predefiniti già compilati.',
  'onboarding.thresholds.save': 'Salva soglie',
  'onboarding.thresholds.saved': 'Soglie salvate.',
  'onboarding.tour.title': 'Tour guidato dell’interfaccia',
  'onboarding.tour.subtitle': 'Un percorso interattivo tra le principali aree del sistema.',
  'onboarding.tour.start': 'Avvia tour',
  'onboarding.tour.next': 'Avanti',
  'onboarding.tour.prev': 'Indietro',
  'onboarding.tour.skip': 'Salta tour',
  'onboarding.tour.finish': 'Concludi',
  'onboarding.tour.counter': '{current}/{total}',
  'onboarding.tour.step.intro.title': 'Benvenuto in Aura Nota',
  'onboarding.tour.step.intro.body': 'Questo tour rapido mostra dove sono le aree principali: upload, documenti, catalogo e impostazioni.',
  'onboarding.tour.step.upload.title': 'Upload dei documenti',
  'onboarding.tour.step.upload.body': 'Invia qui PDF, XML e immagini di NFS-e e fatture — l’estrazione è automatica.',
  'onboarding.tour.step.documents.title': 'Documenti',
  'onboarding.tour.step.documents.body': 'Tutti i documenti catturati sono qui, con stato di estrazione e revisione.',
  'onboarding.tour.step.catalogo.title': 'Catalogo dei comuni',
  'onboarding.tour.step.catalogo.body': 'Consulta la copertura comune → provider NFS-e e suggerisci nuovi mapping.',
  'onboarding.tour.step.settings.title': 'Impostazioni del tenant',
  'onboarding.tour.step.settings.body': 'Gestisci utenti, provider, e-mail, conservazione e soglie dell’organizzazione.',
  'onboarding.tour.step.done.title': 'Tour concluso',
  'onboarding.tour.step.done.body': 'Fatto! Completa la fase per finalizzare la checklist di onboarding.',
  'onboarding.done.title': 'Onboarding concluso!',
  'onboarding.done.body': 'L’organizzazione è configurata e pronta a catturare documenti.',
  'onboarding.done.notified': '{count} partner notificato/i della conclusione.',
  'onboarding.done.goUpload': 'Invia il primo documento',
  'onboarding.done.goSettings': 'Apri impostazioni',
};
